/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 관리자 로그인 박스
 * 버전 : 1.0
 * 파일명 : AdLoginBox.ts
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정 : 2026-01-30, 강동형 : 일반 사용자도 로그인 가능하게 변경
 * 수정 : 2026-02-04, 강동형 : 토큰 갱신 시점 변경
 * ================================================================ */

import { styled } from '@mui/material'
import React, { useState } from 'react'
import InputBoxOnChange from '../inputbox/InputBoxOnChange'
import { NextButton } from '../common/CommonStyled'
import { useStorageStore } from 'src/stores/StorageStore'
import { postToken } from 'src/api/Auth'
import { refetchUser } from 'src/utils/RefetchUser'
import { useNavigate } from 'react-router-dom'
import { useAdLoginStore } from 'src/stores/AdLoginStore'

const PageWrapper = styled('div')(({theme})=>({
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    flexDirection: 'column',
    gap:'50px',

    position:'absolute',
    zIndex:1,
    width:'100%',
    height:'calc(100% - 90px)',
    top:0
}))

const HeaderWrapper = styled('span')(({theme})=>({
    fontWeight:'bold',
    fontSize:'38px',
    color:'white'
}))

const LoginForm = styled('form')(({theme})=>({
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    flexDirection:'column',
    gap:'10px',

    backgroundColor:'white',
    padding:'32px',
    boxShadow: '3px 5px 15px 0px rgba(0, 0, 0, 0.15)',
    borderRadius:'5px',
    // width:'100%',
    minWidth:'420px'
}))

const ButtonWrapper = styled('div')(({theme})=>({
    display:'flex',
    justifyContent:'space-between',
    alignItems:'center',
    width:'100%',
}))

const ButtonContiner = styled('div')(({theme})=>({
    display:'flex',
    justifyContent: 'flex-start',
    alignItems:'center',
    gap: '5px'
}))

const ButtonbBox = styled('button')(({theme})=>({
    all:'unset',
    cursor:'pointer'
}))

const InvalidSpan = styled('span', {
    shouldForwardProp: (prop) => prop !== 'visible', // ⚠️ 필수: MUI에서 custom prop 필터링
  })<{ visible: boolean }>(({ visible }) => ({
    fontSize: '14px',
    color: 'red',
    display: visible ? 'inline' : 'none',
    position: 'absolute',
  }));

interface Props{
    setModal : React.Dispatch<React.SetStateAction<boolean>>
}

const AdLoginBox = ({setModal}:Props) => {
    const storage = useStorageStore()
    const savedId = storage.getItem('savedId');
    const savingId = storage.getItem('savingId');
    const navigate = useNavigate();
    const setField = useAdLoginStore((state)=>state.setField)
    const [saveId, setSaveId] = useState(() => {return savingId === 'true';});
    const [userId, setUserId] = useState(savingId ? savedId : "")
    const [userPw, setUserPw] = useState("")
    const [isVisible, setIsVisible] = useState(false)
    
    const handleSaveId = (e:boolean)=>{
        storage.setItem('savingId', e.toString())
        setSaveId(e)
    }
    const handleSubmit = async(e:React.FormEvent)=>{
        e.preventDefault()
        try {
            const response = await postToken(userId, userPw);

            if (response.access_token) {
            // 1) 토큰 저장이 끝날 때까지 기다림
            await storage.setItem("token", response);
            if (saveId){
                await storage.setItem('savedId',userId)
            }
            else{ 
                await storage.setItem('savedId',null)
            }
            
            } else {
            console.error("로그인 실패:", response.message);
            setIsVisible(true)
            if(response.status === 424){
                setModal(true)
            }
            if(response.status === 423){
                // setField('userName',username.current)
                // navigate('/signup-deny')
            }
            if(response.status === 404){
                // console.log('관리자 권한 없음');
            }
            }
        } catch (error) {
            console.error("로그인 요청 오류:", error);
        } finally {
            await refetchUser()
            // 2) 그 다음에 페이지 이동
            navigate('/admin/achive');
        }
    };
    const onChangeId = (e:React.ChangeEvent<HTMLInputElement>)=>{
        setUserId(e.target.value)
    }
    const onChangePw = (e:React.ChangeEvent<HTMLInputElement>)=>{
        setUserPw(e.target.value)
    }
  return (
    <PageWrapper>
        <HeaderWrapper>로그인</HeaderWrapper>
        <LoginForm onSubmit={handleSubmit}>
            <span style={{textAlign:'left', width:'100%'}}>아이디</span>
            <InputBoxOnChange placeholder='아이디를 입력하세요.' value={userId ?? ""} onChange={onChangeId}/>
            <span style={{textAlign:'left', width:'100%', marginTop:'10px'}}>비밀번호</span>
            <InputBoxOnChange type='password' placeholder='비밀번호를 입력하세요.' value={userPw} onChange={onChangePw}/>
            <ButtonWrapper>
                <ButtonContiner><input type="checkbox" checked={saveId} onChange={(e) => handleSaveId(e.target.checked)}/>아이디 저장</ButtonContiner>
                <ButtonContiner>
                    <ButtonbBox type="button" onClick={()=>setField('tab','FindId')}>아이디 찾기</ButtonbBox>
                    |
                    <ButtonbBox type="button" onClick={()=>setField('tab','FindPw')}>비밀번호 찾기</ButtonbBox>
                </ButtonContiner>
            </ButtonWrapper>
            <div style={{position:'relative', width:'100%', marginBottom:'20px'}}>
                <InvalidSpan visible={isVisible}>* 아이디 또는 비밀번호 오류입니다.</InvalidSpan>
            </div>
            <NextButton type='submit'>로그인</NextButton>
        </LoginForm>
    </PageWrapper>
  )
}

export default AdLoginBox